import eventBus from '../_00_elements/tools/event-bus';
import { flashBagError, flashBagSuccess } from '../_00_elements/tools/flashbag';
import requests from '../_00_elements/tools/requests';
import Logger from '../_00_elements/tools/logger/logger';
import translation from '../_00_elements/tools/translations/translations';
import { trans } from '../_00_elements/translation';
import momentMixin from '../_00_elements/tools/moment';
import { URL_OFFER_PROPOSAL_ADD, URL_OFFER_PROPOSAL_REMOVE } from '../_00_elements/tools/routes/routes';
import { OFFER_EVENT, SLIDERS } from '../_03_organisms/offer/constants';
import { FAVORITE_PROPOSAL_EVENT, PROPOSAL_EVENT } from './constants';
import { apiRemoveProposal } from '../_03_organisms/proposal/proposal';

function dispatchEvent(event, data = {}) {
  eventBus.dispatchEvent(
    new CustomEvent(event, { detail: data }),
  );
}

async function callAddProposalApi({
  hashIds, teamSize, comment, sendMail, teamSizeList = null,
}) {
  let response;

  try {
    response = await requests.post(URL_OFFER_PROPOSAL_ADD, {
      hashIds,
      teamSize,
      comment,
      sendMail,
      teamSizeList,
    });
  } catch (error) {
    flashBagError();
    Logger.error(error);
    return;
  }

  if (!response || response.status !== 200 || !response.data) {
    flashBagError();
    Logger.error('Proposal backend call, response nok');
    return;
  }

  const {
    success = false, proposalId = null, pipedriveUser = {}, label = '',
  } = response.data;

  if (!success) {
    return;
  }

  dispatchEvent(FAVORITE_PROPOSAL_EVENT.OFFER_PROPOSAL_TOGGLE_CALLBACK, {
    label,
    message: comment,
    date: momentMixin.methods.getSimpleDate(new Date().toISOString()),
    pipedriveUser,
  });
  dispatchEvent(PROPOSAL_EVENT.ADDED, { proposalId, offersHashId: hashIds });

  flashBagSuccess(trans('sliders.offer_proposal.flashbag_success'));
}

async function callRemoveProposalApi({ proposalId, offersHashId }) {
  let response;

  try {
    response = await requests.delete(URL_OFFER_PROPOSAL_REMOVE.replace('{id}', proposalId), { proposalId, refusedByUser: false });
  } catch (error) {
    Logger.error(error);
    flashBagError();
    return;
  }

  if (!response || response.status !== 200 || !response.data) {
    flashBagError();
    Logger.error('Proposal backend call, response nok');
    return;
  }

  const { success = false } = response.data;

  if (!success) {
    return;
  }

  dispatchEvent(PROPOSAL_EVENT.REMOVED, { proposalId, offersHashId, refusedByUser: false });
  flashBagSuccess(trans('offer_card.labels.proposal_removed'));
}

const init = () => {
  eventBus.addEventListener(
    FAVORITE_PROPOSAL_EVENT.OFFER_PROPOSAL_ADD,
    (event) => {
      const { offersHashId, teamSize, teamSizeList } = event.detail;
      const menuSelector = document.querySelector('.menu-auth');

      if (menuSelector?.dataset?.isSeller === '1') {
        // eslint-disable-next-line no-alert
        const confirm = window.confirm(translation().messages['proposal.added.not_seller_user']);
        if (!confirm) {
          dispatchEvent(FAVORITE_PROPOSAL_EVENT.CANCEL_PROPOSAL_ADDITION);
          return;
        }
      }

      dispatchEvent(OFFER_EVENT.SLIDER_SHOW, {
        sliderType: SLIDERS.OFFER_PROPOSAL,
        sliderPayload: {
          hashIds: offersHashId,
          teamSize,
          teamSizeList,
        },
      });
    },
  );

  eventBus.addEventListener(
    FAVORITE_PROPOSAL_EVENT.OFFER_PROPOSAL_REMOVE,
    (event) => {
      const { proposalId, offersHashId } = event.detail;
      callRemoveProposalApi({ proposalId, offersHashId });
    },
  );

  eventBus.addEventListener(FAVORITE_PROPOSAL_EVENT.OFFER_SAVE_PROPOSAL, (event) => {
    const { hashIds, teamSize, comment, sendMail, teamSizeList } = event.detail;
    callAddProposalApi({
      hashIds,
      teamSize,
      comment,
      sendMail,
      teamSizeList,
    });
  });

  eventBus.addEventListener(
    FAVORITE_PROPOSAL_EVENT.OFFER_REFUSE_PROPOSAL_TOGGLE,
    (event) => {
      const { proposalId } = event.detail;
      dispatchEvent(OFFER_EVENT.SLIDER_SHOW, {
        sliderType: SLIDERS.REFUSE_PROPOSAL,
        sliderPayload: {
          id: proposalId,
          accountManager: window.initialAppState.account_manager,
        },
      });
    },
  );

  eventBus.addEventListener(OFFER_EVENT.PROPOSAL_OFFER_REMOVE, async (event) => {
    const { proposalId, refusalReasons, refusedByUser } = event.detail;
    await apiRemoveProposal({ proposalId, refusalReasons, refusedByUser });
    dispatchEvent(OFFER_EVENT.PROPOSAL_REFUSE, { proposalId });
    dispatchEvent(PROPOSAL_EVENT.REMOVED, { proposalId });
  });
};

export default init;
